import { BCInputMultiLanguage } from '@bimser/components';
import { IDictionary, MLHelper } from '@bimser/core';
import React from 'react';

type Props = {
	title: IDictionary<string>;
	onChange: (title: IDictionary<string>) => void;
	maxLength: number;
};

export const TitleModal: React.FC<Props> = props => {
	const titleRef = React.useRef(props.title);

	const onLanguageValueChange = (culture: string, value: string) => {
		const newTitle: IDictionary<string> = {
			...titleRef.current,
			[culture]: value
		};

		titleRef.current = newTitle;

		props.onChange(newTitle);
	};

	return (
		<BCInputMultiLanguage
			values={titleRef.current}
			onLanguageValueChange={onLanguageValueChange}
			currentLanguage={MLHelper.currentLanguage}
			supportedLanguages={MLHelper.supportedLanguages}
			maxLength={props.maxLength}
		/>
	);
};
